import { SET_TIMEZOME } from "./constants";

export const changeTimezone = (timezone) => async (dispatch) => {
  dispatch({
    type: SET_TIMEZOME,
    payload: timezone,
  });
};
